const DEFAULT_PHOTO_URL_PREFIXES = [
  'https://withjoy.com/assets/public/wedding-website/designs-gallery/default-assets/',
  'https://withjoy.com/assets/public/marcom-prod/wedding-website-gallery/gallery_thumbnails/default_preview_images/',
  'https://withjoy.com/assets/public/defaultwebsitephotos/',
  'https://withjoy.com/assets/public/createwedding/seed-wedding-templates/',
];

const STOCK_PHOTO_FILENAME_PATTERNS = [/^classic_wedding_/i, /-unsplash/i];

const STOCK_PHOTO_URLS = [
  'https://withjoy.com/media/ea08b6c9814abe8d85f1f6999d73bd9afb9536716d12561b3/Kyhc6muKTs6gtn2hF7t7_w_couple_marshall_lily_kissing_hidden_underpass%20copy.jpg',
];

export function isDefaultPlaceholderUrl(url: string): boolean {
  if (DEFAULT_PHOTO_URL_PREFIXES.some(prefix => url.startsWith(prefix))) return true;
  try {
    const parsed = new URL(url);
    if (parsed.searchParams.get('isDefault') === 'true') return true;
    const basename = parsed.pathname.slice(parsed.pathname.lastIndexOf('/') + 1);
    if (STOCK_PHOTO_FILENAME_PATTERNS.some(re => re.test(basename))) return true;
    if (STOCK_PHOTO_URLS.includes(`${parsed.origin}${parsed.pathname}`)) return true;
  } catch {
    // not a parseable absolute URL
  }
  return false;
}
